export default __webpack_public_path__ + "static/media/ma_baatar_ar.2b6ab8f7.jpg";